import { render, staticRenderFns } from "./SecureBack.vue?vue&type=template&id=d708082c"
import script from "./SecureBack.vue?vue&type=script&lang=js"
export * from "./SecureBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports